import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgClockFive = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m12.844 11.743 2.078 3.164c.288.387.182.911-.204 1.14a.814.814 0 0 1-1.171-.204l-2.25-3.375a.85.85 0 0 1-.14-.468V7.219c0-.468.375-.844.843-.844s.844.376.844.844zM21 12a9 9 0 0 1-9 9 9 9 0 0 1-9-9 9 9 0 0 1 9-9 9 9 0 0 1 9 9m-9-7.312A7.31 7.31 0 0 0 4.688 12 7.31 7.31 0 0 0 12 19.313 7.31 7.31 0 0 0 19.313 12 7.31 7.31 0 0 0 12 4.688"
    }));
export default SvgClockFive;
